export type PageProps = {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};
export function Page({ className, style, children }: PageProps) {
  return (
    <main className={`mb-24 flex ${className ?? ''}`.trim()} style={style}>
      {children}
    </main>
  );
}
